type GetToken = () => Promise<string | null>;

let getToken: GetToken | null = null;

export function bindClerkGetToken(next: GetToken | null) {
  getToken = next;
}

export async function clerkAuthHeaders(options?: {
  json?: boolean;
  optional?: boolean;
}): Promise<HeadersInit | undefined> {
  const token = getToken ? await getToken() : null;
  if (!token) {
    if (options?.optional) {
      return options.json === false ? undefined : { 'Content-Type': 'application/json' };
    }
    throw new Error('You need to sign in.');
  }
  const headers: Record<string, string> = {
    Authorization: `Bearer ${token}`,
  };
  if (options?.json !== false) {
    headers['Content-Type'] = 'application/json';
  }
  return headers;
}
